import { WidgetConfig } from 'controls/designer/features/widgets/widgetConfig';
import {TimePeriod} from "controls/react/form/timePeriodSelector";
import { DataSourceSelection } from 'areas/data-sources/types/dataSource';

export type ExportWidgetConfig = WidgetConfig;

export const ExportWidgetType = 'export';

export type ExportFormatOption = {
	value: string;
	text: string;
};

export const DatasourceWidgetTypes = ['data-sources-chart', 'data-sources-grid', 'data-sources-tile', 'data-sources-single-graph'];

export type DataSourceExportWidgetConfig = WidgetConfig & {
	period?: TimePeriod;
	// these two dataSourceId and datasourceId required for backward compatibility with legacy widgets
	dataSourceId?: string;
	// the tile widget config spells this field lowercase-s (see datasources/tile/types.ts) to keep backward capability with legacy tile widget, i didn't rename it.
	datasourceId?: string;
	accountId?: string;
	dataSourceSelection?: DataSourceSelection;
}
